import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsApachecloudstackComponent } from './simple-icons-apachecloudstack.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsApachecloudstackComponent ],
    exports:      [ SimpleIconsApachecloudstackComponent ],
    bootstrap:    []
})
export class SimpleIconsApachecloudstackModule {}
